const emitir_relatório_de_matricula_diaria_por_escola_ensino = {
  path: "/emitir-relatorio-de-matricula-diaria-por-escola-ensino",
  redirect: "/emitir_relatorio_de_matricula_diaria_por_escola_ensino",
  meta: {
    breadCrumb: "Processo de Matrículas - Retrato de Matrícula Diária",
  },
  children: [
    {
      path: "/emitir-relatorio-de-matricula-diaria-por-escola-ensino",
      name: "emitir_relatorio_de_matricula_diaria_por_escola_ensino",
      component: () =>
        import(
          "@/views/EmitirRelatorioDeMatriculaDiariaPorEscolaEnsino/EmitirRelatorioDeMatriculaDiariaPorEscolaEnsinoHome.vue"
        ),
    },
  ],
};

export { emitir_relatório_de_matricula_diaria_por_escola_ensino };
